import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { RegulationService } from 'src/app/core/services/regulation';
import { LibraryType } from 'src/app/core/enums/regulator/regulator-status';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { ChangeViewerLibrary } from 'src/app/core/models/regulation/change-viewer-library';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { Store } from '@ngrx/store';
import { updateNavHeight } from 'src/app/state/grouping/grouping.actions';

@Component({
  selector: 'app-change-viewer-landing',
  templateUrl: './change-viewer-landing.component.html',
  styleUrls: ['./change-viewer-landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ChangeViewerLandingComponent implements OnInit, AfterViewInit {
  roleId: number;
  libraryMenu: Array<MenuItemModel>;

  @ViewChild('componentIdentifier')
  componentIdentifier!: ElementRef;


  // Fixed top
  @ViewChild('changeViewerNav')
  changeViewerNav!: ElementRef;

  constructor(
    public sessionService: SessionService,
    private analyticsService: AnalyticsService,
    public regulationService: RegulationService,
    private router: Router,
    private _userService: UserService,
    private cdRef: ChangeDetectorRef,
    private eleRef: ElementRef,
    private generalService: GeneralDataService,
    private store: Store
  ) {
    this.libraryMenu = [];
    this.roleId = 0;
  }

  ngOnInit(): void {
    this.getUserMenu();
    this.fetchRegulationLibrary();
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
    this.generalService.setLandingComponentIdentifire(this.componentIdentifier);

  }
  getUserMenu(): void {
    if (this._userService.menueItems.length === 0) {
      this.analyticsService.getLibraryMenu().subscribe((data: MenuItemModel[]) => {
        this.libraryMenu = data;
        setTimeout(() => {
          this.calcNavHeight()
        }, 50);
      });
    }
    else {
      this.libraryMenu = this._userService.menueItems;
      setTimeout(() => {
        this.calcNavHeight()
      }, 50);
    }


  }

  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(a => a.screenUrl === currentUrl && a.parentId != null) ? true : false;
  }

  fetchRegulationLibrary(): void {
    if (this._userService.isLibraryCallingFirstTime) {
      this.regulationService.getRegulationLibrary('OrderNo', false).subscribe((data: Array<ChangeViewerLibrary>) => {
        if (data) {
          this.regulationService.regulationLibrary = data.filter(a => a.isActive);
          this._userService.userLibrary = this.regulationService.regulationLibrary;
        }
        this._userService.isLibraryCallingFirstTime = false;
      });
    }
    else {
      this.regulationService.regulationLibrary = this._userService.userLibrary;
    }
  }

  calcNavHeight() {
    if (this.changeViewerNav) {
      let navHeight = this.changeViewerNav.nativeElement.offsetHeight;
      // this.eleRef.nativeElement.style.setProperty('--dd-nav-height', navHeight + 'px');
      this.store.dispatch(updateNavHeight({ data: navHeight }))
    }

  }


  getIconClass(type: LibraryType): string {
    return type === LibraryType.Static ? 'fa fa-thumb-tack' : 'fa fa-bolt';
  }

  redirectLibrary(id:number, libraryType:string) {
    this.router.navigate([
      "/change-viewer/regulation-library/" + id + "/" + libraryType + ""
    ]);
  }

}


